import { useApp } from '../../state/AppContext';
import { badge, zeb } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function WbCases() {
  const { L } = useApp();
  const wbKpis = [
    { label: L('Open Cases', 'เคสที่เปิด'), value: '2', color: 'var(--color-warning)' },
    { label: L('Under Investigation', 'อยู่ระหว่างสอบสวน'), value: '1', color: 'var(--color-warning)' },
    { label: L('Resolved (FY)', 'แก้ไขแล้ว (ปีงบ)'), value: '5', color: 'var(--color-success)' },
    { label: L('Anonymous', 'ไม่ระบุตัวตน'), value: L('6 of 8', '6 จาก 8'), color: 'var(--color-fg-1)' },
  ];
  const wbRows = [
    { ref: 'WB-2026-0007', cat: 'Bid rigging', summary: 'Suspected coordinated pricing on RFQ-2026-004.', priority: 'High', anon: true, evText: '2 files', assigned: 'Audit Committee', status: 'Under Investigation' },
    { ref: 'WB-2026-0005', cat: 'Conflict of interest', summary: 'Officer related to an invited supplier.', priority: 'Medium', anon: true, evText: '1 file', assigned: 'Wendy N.', status: 'Open' },
    { ref: 'WB-2026-0002', cat: 'Kickback', summary: 'Alleged gift from a shortlisted bidder.', priority: 'High', anon: false, evText: '3 files', assigned: 'Audit Committee', status: 'Resolved' },
  ].map((w, i) => {
    const b = badge(w.status);
    const p = w.priority === 'High' ? { bg: 'var(--color-error-bg)', fg: 'var(--color-error)' } : (w.priority === 'Medium' ? { bg: 'var(--color-warning-bg)', fg: 'var(--color-warning)' } : { bg: 'var(--color-success-bg)', fg: 'var(--color-success)' });
    const catTh: Record<string, string> = { 'Bid rigging': 'ฮั้วประมูล', 'Conflict of interest': 'ผลประโยชน์ทับซ้อน', 'Kickback': 'เงินใต้โต๊ะ' };
    const priTh = w.priority === 'High' ? 'สูง' : w.priority === 'Medium' ? 'กลาง' : w.priority;
    const statTh = w.status === 'Under Investigation' ? 'อยู่ระหว่างสอบสวน' : w.status === 'Open' ? 'เปิด' : w.status === 'Resolved' ? 'แก้ไขแล้ว' : w.status;
    return {
      ...w,
      zebra: zeb(i),
      stBg: b.bg,
      stFg: b.fg,
      pBg: p.bg,
      pFg: p.fg,
      cat: L(w.cat, catTh[w.cat] ?? w.cat),
      priority: L(w.priority, priTh),
      status: L(w.status, statTh),
      assigned: L(w.assigned, w.assigned === 'Audit Committee' ? 'คณะกรรมการตรวจสอบ' : w.assigned),
      evText: L(w.evText, w.evText.replace('files', 'ไฟล์').replace('file', 'ไฟล์')),
      anon: w.anon ? L('Anonymous', 'ไม่ระบุตัวตน') : L('Named', 'ระบุตัวตน'),
    };
  });

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {wbKpis.map((k) => (
          <div key={k.label} style={cardPad('16px 18px')}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-mono)', color: k.color }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={cardPad(0, 'auto')}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Case Register', 'ทะเบียนเคส')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 960 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Case Ref', 'เลขที่เคส')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Category', 'หมวดหมู่')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Summary', 'สรุป')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Priority', 'ความสำคัญ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Anon', 'การระบุตัวตน')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Evidence', 'หลักฐาน')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Assigned To', 'มอบหมายให้')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Status', 'สถานะ')}</th>
            </tr>
          </thead>
          <tbody>
            {wbRows.map((w) => (
              <tr key={w.ref} style={{ borderBottom: '1px solid var(--color-border)', background: w.zebra }}>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{w.ref}</td>
                <td style={{ padding: '12px 16px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{w.cat}</span></td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)', maxWidth: 260 }}>{w.summary}</td>
                <td style={{ padding: '12px 16px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: w.pBg, color: w.pFg }}>{w.priority}</span></td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{w.anon}</td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{w.evText}</td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{w.assigned}</td>
                <td style={{ padding: '12px 16px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: w.stBg, color: w.stFg }}>{w.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
